import {
  USER_EVENTS_NEWS_REQUEST,
  USER_EVENTS_NEWS_SUCCESS,
  USER_EVENTS_NEWS_FAIL,
  CLEAR_ERRORS,
} from "../constants/commonConstants";

const initialState = {
  userEventsNews: [],
  loading: false,
  error: null,
};

export const userEventsNewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_EVENTS_NEWS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_EVENTS_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        userEventsNews: action.payload,
      };
    case USER_EVENTS_NEWS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
